import { Link } from "react-router-dom";
import { Sparkles, Instagram, Facebook } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-[#FFFDF8] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.png" alt="Alekas Treats" className="h-16 w-auto bg-white p-1" />
            <span className="font-heading text-3xl tracking-wider">ALEKAS TREATS</span>
          </div>
          <p className="text-[#FDF4E3]/70 max-w-md leading-relaxed">Chamoy candy crafted with 100% Mexican spices. Retail direct or wholesale to gas stations, vape shops, smoke shops and mom-and-pops across the USA.</p>
          <div className="mt-6 space-y-1 text-sm text-[#FDF4E3]/70">
            <div><a href="mailto:alexia@alekastreats.com" className="hover:text-[#FFB300]">alexia@alekastreats.com</a></div>
            <div><a href="mailto:mrspann@alekastreats.com" className="hover:text-[#FFB300]">mrspann@alekastreats.com</a></div>
          </div>
        </div>
        <div>
          <h4 className="font-heading text-lg tracking-widest uppercase text-[#FFB300] mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-[#FDF4E3]/80">
            <li><Link to="/shop" className="hover:text-[#FFB300]">Retail store</Link></li>
            <li><Link to="/club" className="hover:text-[#FFB300]">Chamoy Club</Link></li>
            <li><Link to="/wholesale" className="hover:text-[#FFB300]">Wholesale application</Link></li>
            <li><Link to="/request" className="hover:text-[#FFB300]">Request a candy</Link></li>
            <li><Link to="/orders" className="hover:text-[#FFB300]">Track your order</Link></li>
            <li><Link to="/login" className="hover:text-[#FFB300]">Buyer portal</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-lg tracking-widest uppercase text-[#FFB300] mb-4">Follow</h4>
          <div className="flex flex-col gap-3 text-sm text-[#FDF4E3]/80">
            <a href="https://www.tiktok.com/@alekastreatsllc" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#FFB300]" data-testid="social-tiktok"><Sparkles size={16} /> TikTok · @alekastreatsllc</a>
            <a href="https://www.instagram.com/alekastreatsllc" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#FFB300]" data-testid="social-instagram"><Instagram size={16} /> Instagram · @alekastreatsllc</a>
            <a href="https://www.facebook.com/alekastreatsllc" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#FFB300]" data-testid="social-facebook"><Facebook size={16} /> Facebook · alekastreatsllc</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-[#FDF4E3]/50 tracking-widest uppercase">
        © {new Date().getFullYear()} Alekas Treats LLC · 100% Mexican spices · Made with fuego
      </div>
    </footer>
  );
}
